import { createFileRoute } from '@tanstack/react-router';

import { VerifyEmailChange } from 'src/apps/verifyNewEmail/app/VerifyEmailChange';

export const Route = createFileRoute('/_auth/_only-header/verify-new-email')({
  component: () => <VerifyEmailChange />,
});
